/**
 * @generated SignedSource<<5138e291ae52e317ca31a49ce31bf59a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type RewardKind = "CrmTreeHeadUpdater" | "ExternalLicense" | "GamificationPoints" | "IHKCertificate" | "IHKCertificateBundle" | "LearnStreak";
import { FragmentRefs } from "relay-runtime";
export type rewardForm_RewardFragment$data = {
  readonly id: string;
  readonly kind: RewardKind;
  readonly " $fragmentSpreads": FragmentRefs<"externalLicenseRewardForm_ExternalLicenseRewardFragment" | "ihkCertificateRewardBundleForm_IHKCertificateRewardBundleFragment">;
  readonly " $fragmentType": "rewardForm_RewardFragment";
};
export type rewardForm_RewardFragment$key = {
  readonly " $data"?: rewardForm_RewardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"rewardForm_RewardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "rewardForm_RewardFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "externalLicenseRewardForm_ExternalLicenseRewardFragment"
        }
      ],
      "type": "ExternalLicenseReward",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ihkCertificateRewardBundleForm_IHKCertificateRewardBundleFragment"
        }
      ],
      "type": "IHKCertificateBundle",
      "abstractKey": null
    }
  ],
  "type": "Reward",
  "abstractKey": "__isReward"
};

(node as any).hash = "ae594f2ec4c53d2b3596d759dad8fd85";

export default node;
